export const supSerializer = (props: any) => <sup>{props.children}</sup>;
